module.exports = __webpack_public_path__ + "static/img/Matisse-Thybulle.a46def6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matisse-Thybulle.jpg
// module id = p2lB
// module chunks = 1